export type AccessibilityTextSize = 'default' | 'large' | 'extra-large';
export type AccessibilityTextSpacing = 'default' | 'increased' | 'maximum';
export type AccessibilityContentSpacing = 'default' | 'comfortable' | 'expanded';
export type AccessibilityContrast = 'default' | 'high-contrast-light' | 'high-contrast-dark';

export interface AccessibilityPreferences {
  textSize: AccessibilityTextSize;
  textSpacing: AccessibilityTextSpacing;
  contentSpacing: AccessibilityContentSpacing;
  contrast: AccessibilityContrast;
  readableFont: boolean;
  highlightLinks: boolean;
  enhancedFocus: boolean;
  reduceMotion: boolean;
  pauseAnimations: boolean;
}

export const DEFAULT_ACCESSIBILITY_PREFERENCES: AccessibilityPreferences = {
  textSize: 'default',
  textSpacing: 'default',
  contentSpacing: 'default',
  contrast: 'default',
  readableFont: false,
  highlightLinks: false,
  enhancedFocus: false,
  reduceMotion: false,
  pauseAnimations: false,
};
